import avatar from '../../../assets/estelle-avatar.webp';
import photo from '../../../assets/estelle-de-truchis-de-varennes.webp';

// Autrice des guides et articles du site vitrine (signature, encadré et page auteur)
export const AUTHOR = {
  name: 'Estelle de Truchis de Varennes',
  avatar,
  photo,
  path: '/estelle-de-truchis-de-varennes',
  role: 'Fondatrice de RSVP Please',
  linkedin: 'https://www.linkedin.com/in/estelle-detruchisdevarennes',
  company: { name: 'Coding Capital', url: 'https://www.coding-capital.com/' },
  short:
    'Ingénieure et cofondatrice de Coding Capital, Estelle a créé RSVP Please en préparant son propre mariage : l’outil qu’elle aurait aimé avoir, 100 % gratuit pour tous les futurs mariés.',
};

export const AUTHOR_URL = `https://www.please-rsvp.com${AUTHOR.path}`;
